import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import secureLocalStorage from 'react-secure-storage';
import Sidebar from './Sidebar';
import Overview from '../../components/Views/Overview/Overview';
import Settings from '../../components/Views/Settings/Settings';
import Logbooks from '../../components/Views/Logbooks/Logbooks';
import Edit from '../../components/Views/Edit/Edit';
import Export from '../../components/Views/Export/Export';
import Payment from '../../components/Views/Payment/Payment';
import styles from './Dashboard.module.css';
import { useActivePage } from '../../contexts/ActivePageContext';
import { useAuth } from '../../contexts/AuthContext';

function Dashboard() {
  const { activePage, setActivePage } = useActivePage();
  const { logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const userString = localStorage.getItem('user');
  const user = userString ? JSON.parse(userString) : null;

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  // Check for subscribe flag on mount
  useEffect(() => {
    if (location.state?.subscribe) {
      // For example, set the activePage to payment
      setActivePage('payment');

      // Optionally clear the state so it doesn't trigger again
      navigate(location.pathname, { replace: true, state: {} });
    }
  }, [location, navigate, setActivePage]);

  if (!user) {
    return <p className={styles.noUser}>No user found</p>;
  }

  const renderContent = () => {
    switch (activePage) {         
      case 'overview':
        return <Overview />;
      case 'settings':
        return <Settings />;
      case 'logbooks':
        return <Logbooks />;
      case 'export':                           
        return <Export />;
      case 'edit':                           
        return <Edit />;
      case 'payment':                           
        return <Payment />;
      default:
        return <Overview />;
    }
  };

  return (
    <div className={styles.dashboard}>
      <Sidebar onLogout={handleLogout} />
      <div className={styles.main}>
        <div className={styles.content}>
          {renderContent()}
        </div>
      </div>
    </div>
  );
}

export default Dashboard;
